import React from 'react';
import PropTypes from 'prop-types';
import AdminDrawer from '../components/admin/drawer';

export default function AdminLayout({ children }) {
	return (
		<div className="admin-full-wrap">
			<AdminDrawer />
			{children}
		</div>
	);
}

AdminLayout.propTypes = {
	children: PropTypes.any,
};
